import React from 'react'
import { View, Text, Platform } from 'react-native'
import themes from '../../../theme'
import StyledText from '../../../StyledText'
import Hyperlink from 'react-native-hyperlink'
import { useNavigation } from '@react-navigation/native'
import styles from './DescriptionPostsStyles'
import { warn } from '../../utils/logger'

const DescriptionPosts = ({ posts }) => {
    let navigation = null
    try {
        navigation = useNavigation()
    } catch (e) {
        if (Platform.OS === 'web') {
            navigation = { navigate: () => {} }
            if (process?.env?.NODE_ENV !== 'production') warn('Posts', '[DescriptionPosts] useNavigation fallback (web)')
        } else {
            throw e
        }
    }
    const goWebView = (url) => {
        if (!url) return
        if (Platform.OS === 'web') {
            try {
                window?.open(url, '_blank', 'noopener,noreferrer')
                return
            } catch {}
        }
        navigation.navigate('WebView', { link: url })
    }

    return (
        <View style={styles.descriptionPost}>
            {posts.title && (
                <StyledText fontWeight='bold' fontSize='normalText'>
                    {posts.title}
                </StyledText>
            )}

            <View style={styles.views} />

            {posts.description_short && (
                <Hyperlink
                    onPress={(url) => goWebView(url)}
                    linkStyle={{ color: themes.colors?.colorPrimary || '#1B95E0', textDecorationLine: 'underline' }}
                    linkDefault={false}
                >
                    <StyledText fontWeight='normal' fontSize='normalText'>
                        {posts.description_short}
                    </StyledText>
                </Hyperlink>
            )}
        </View>
    )
}

export default DescriptionPosts
